import { render, staticRenderFns } from "./results_modal.vue?vue&type=template&id=3bffd9d8&scoped=true&"
import script from "./results_modal.vue?vue&type=script&lang=js&"
export * from "./results_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffd9d8",
  null
  
)

export default component.exports